export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13174.f74564a5.jpg";